const handlers = {
  500: getMfaErrorRedirect,
  412: get412Redirect
}

function getMfaErrorRedirect (error) {
  if(error.response.data.indexOf("MFA") !== -1){
    return 'error-mfa-not-set';
  } else if (error.response.data.indexOf("Workplace") !== -1){
    return 'error-wp-not-invited';
  } else {
    return 'error-catch-all';
  }
}

function get412Redirect (error) {
  if (error.response.data.indexOf("error-not-provisioned") !== -1) {
    console.log("Not provisioned - redirecting");
    return 'not-provisioned';
  } else if (error.response.data.indexOf("error-already-invited-bt") !== -1) {
    console.log("Already Invited - redirecting");
    return {path:'already-invited', query:{url: "https://bt.workplace.com"}}
  } else if (error.response.data.indexOf("error-already-invited-openreach") !== -1) {
    console.log("Already Invited - redirecting");
    return {path:'already-invited', query:{url: "https://openreach.workplace.com"}}
  } else if (error.response.data.indexOf("error-ouc-not-eligible")  !== -1) {
    console.log("OUC not eligible - redirecting") 
    return 'ouc-not-eligible';
  } 
  else {
    console.log("Unknown 412 error: "+error);
    return 'error-catch-all';  
  }
}

function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}


// This exports the plugin object.
export default {
    install (Vue, options) {
        Vue.mixin({
            // Add component lifecycle hooks or properties.
            methods: {
              getErrorRedirect(err) {
                console.debug(err);
                return err.response === undefined ? 'error-catch-all' : handlers[err.response.status](err);
              }
            },
            created () {
                const title = getTitle(this)
                if (title) {
                    document.title = title
                }
            }
        })
    }
  }